import React from 'react'
import { Container, Box } from '@mui/material'
import InvitesTable from './Table'
import InvitesOverview from './InvitesOverview'
import InvitesFilterBar from './InvitesFilterBar'

const InvitesContainer = () => {
    return (
        <Container>
            <InvitesOverview />
            <Box mt={4} mb={16}>
                <InvitesTable />
            </Box>
        </Container>
    )
}

export default InvitesContainer
